import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-8 md:mb-10 text-center">
          {t('comparisonTitle')}
        </h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300">
                <th className="text-left py-4 px-4 md:px-6 text-sm font-semibold text-foreground-900">
                  {t('comparisonCol1')}
                </th>
                <th className="text-center py-4 px-4 md:px-6 text-sm font-semibold text-primary-600">
                  {t('comparisonCol2')}
                </th>
                <th className="text-center py-4 px-4 md:px-6 text-sm font-semibold text-foreground-500">
                  {t('comparisonCol3')}
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                { label: t('comparisonEconomy') },
                { label: t('comparisonQC') },
                { label: t('comparisonLinks') },
                { label: t('comparisonCommunity') },
                { label: t('comparisonSafety') },
              ].map((row, i) => (
                <tr key={i} className="border-b border-background-200">
                  <td className="py-4 px-4 md:px-6 text-sm text-foreground-700">{row.label}</td>
                  <td className="py-4 px-4 md:px-6 text-center">
                    <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-primary-50 text-primary-600">
                      <i className="ri-check-line text-sm"></i>
                    </span>
                  </td>
                  <td className="py-4 px-4 md:px-6 text-center">
                    <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-background-200 text-foreground-400">
                      <i className="ri-close-line text-sm"></i>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}